import AssessmentLayout from './AssessmentLayout';
import { PageWithLayout } from './types';

const AppLayout = ({
  children,
  Layout,
  isGradientBackground
}: PageWithLayout) => {
  if (!Layout) {
    return <AssessmentLayout>{children}</AssessmentLayout>;
  }
  return (
    <Layout isGradientBackground={isGradientBackground}>{children}</Layout>
  );
};

export default AppLayout;
